export interface CategoryConfig {
  name: string;
  depreciationMethod: 'straight-line' | 'reducing-balance';
  depreciationRate: number;
  usefulLife: number;
}

export const ASSET_CATEGORIES: CategoryConfig[] = [
  {
    name: 'IT Equipment',
    depreciationMethod: 'straight-line',
    depreciationRate: 25,
    usefulLife: 4
  },
  {
    name: 'Furniture',
    depreciationMethod: 'straight-line',
    depreciationRate: 15,
    usefulLife: 6
  },
  {
    name: 'Vehicles',
    depreciationMethod: 'reducing-balance',
    depreciationRate: 25,
    usefulLife: 4
  },
  {
    name: 'Plant & Machinery',
    depreciationMethod: 'straight-line',
    depreciationRate: 20,
    usefulLife: 5
  },
  {
    name: 'Office Equipment',
    depreciationMethod: 'straight-line',
    depreciationRate: 33,
    usefulLife: 3
  }
];

export const getCategoryNames = (): string[] => {
  return ASSET_CATEGORIES.map(c => c.name);
};

export const getCategoryConfig = (categoryName: string): CategoryConfig | undefined => {
  return ASSET_CATEGORIES.find(c => c.name === categoryName);
};
